/**
 * Client for the UI preferences endpoint. Uses the project-wide axios
 * instance, so the JWT auth header and `/api/v1` baseURL configured in
 * `src/index.tsx` are picked up automatically.
 */
import axios from 'axios';

export interface QuickLink {
  id: string;
  label: string;
  path: string;
  icon?: string;
  order: number;
}

export interface UiPreferences {
  quick_links: QuickLink[];
  homepage_path: string | null;
}

const ENDPOINT = '/users/user-ui-preferences/me';

export async function getUiPreferences(): Promise<UiPreferences> {
  const { data } = await axios.get<UiPreferences>(ENDPOINT);
  return {
    quick_links: data?.quick_links ?? [],
    homepage_path: data?.homepage_path ?? null,
  };
}

export async function putUiPreferences(payload: UiPreferences): Promise<UiPreferences> {
  const { data } = await axios.put<UiPreferences>(ENDPOINT, payload);
  return {
    quick_links: data?.quick_links ?? [],
    homepage_path: data?.homepage_path ?? null,
  };
}
